import React from "react";
import { TrendingUp, HelpCircle } from "lucide-react";
import { Card } from "@/components/Card/Card";
import { formatCurrency } from "@/modules/stochastic/features/SalesAndCustomerDashboard/utils/chart";

interface MarketingROICardProps {
  totalMatchbackSales: number;
  totalMarketingSpend: number;
  roiPerDollar: number;
}

export const MarketingROICard: React.FC<MarketingROICardProps> = ({
  totalMatchbackSales,
  totalMarketingSpend,
  roiPerDollar,
}) => {
  return (
    <Card className="w-full bg-gradient-to-br from-blue-500 to-blue-600 border-0 shadow-lg">
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2.5 rounded-lg bg-white/20">
            <TrendingUp className="h-6 w-6 text-white" />
          </div>
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-semibold text-white">Marketing ROI</h3>
            <HelpCircle className="h-4 w-4 text-white/70 cursor-help" />
          </div>
        </div>

        {/* Main ROI Value */}
        <div className="mb-6">
          <div className="flex items-baseline gap-2 mb-2">
            <span className="text-5xl font-bold text-white">
              ${roiPerDollar}
            </span>
            <span className="text-white/90 text-lg">return per $1 spent</span>
          </div>
          <p className="text-white/80 text-sm">
            For every $1 spent on direct mail, we generate ${roiPerDollar} in
            sales
          </p>
        </div>

        {/* Bottom Stats */}
        <div className="grid grid-cols-2 gap-6 pt-6 border-t border-white/20">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-white/80 text-sm">
                Total Matchback Sales
              </span>
              <HelpCircle className="h-3.5 w-3.5 text-white/60 cursor-help" />
            </div>
            <div className="text-2xl font-bold text-white">
              {formatCurrency(totalMatchbackSales)}
            </div>
          </div>
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-white/80 text-sm">
                Total Marketing Spend
              </span>
              <HelpCircle className="h-3.5 w-3.5 text-white/60 cursor-help" />
            </div>
            <div className="text-2xl font-bold text-white">
              {formatCurrency(totalMarketingSpend)}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
